import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MUrlService } from './url.service';

@NgModule({
  imports: [CommonModule, RouterModule],
  providers: [MUrlService]
})
export class MUrlModule {}
